// extracted by mini-css-extract-plugin
export var radioInputRow = "z_sn";
export var radioInputColumn = "z_sp";
export var inputOptionRow = "z_pT";
export var inputOptionColumn = "z_pV";